import { styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../../../helix';
/**
 * Styled table used to display a calendar month.
 */
export const CalendarTable = styled('table')(() => ({
    borderSpacing: '0.5rem 0.25rem',
    th: Object.assign({}, HelixStyles.style_05),
    td: {
        padding: 0,
    },
}));
/**
 * Styled button representing a calendar day.
 */
export const StyledDateButton = styled('button')(() => (Object.assign(Object.assign({}, HelixStyles.style_06_medium), { alignItems: 'center', backgroundColor: HelixPalette.white, border: 'none', borderRadius: '100%', display: 'flex', flexDirection: 'column', position: 'relative', height: 35, justifyContent: 'center', width: 35, '&:focus': { outline: 'none' }, '&[data-in-month=false]': { color: HelixPalette.neutral60 }, '&[data-today=true]': { color: HelixPalette.pink60 }, '&[data-selectable=true]': {
        '&:hover': {
            backgroundColor: HelixPalette.teal10,
            cursor: 'pointer',
        },
        '&:active:focus': { backgroundColor: HelixPalette.teal20 },
        '&:focus-visible': {
            backgroundColor: HelixPalette.blue70,
            color: HelixPalette.white,
        },
    }, '&[data-selected=true]': {
        backgroundColor: HelixPalette.teal80,
        color: HelixPalette.white,
    } })));
/**
 * Styled button representing the month/year button.
 */
export const MonthYearButton = styled('button')(() => (Object.assign(Object.assign({}, HelixStyles.style_08), { alignItems: 'center', backgroundColor: 'transparent', border: '2px solid transparent', borderRadius: '0.25rem', display: 'flex', height: 28, '&:focus': { outline: 'none' }, '&:hover': {
        color: HelixPalette.neutral80,
        cursor: 'pointer',
    }, '&:active:focus': { color: HelixPalette.neutral100 }, '&:focus-visible': { borderColor: HelixPalette.blue70 } })));
/**
 * Styled button representing a month/year tile.
 */
export const MonthYearTile = styled('button')(() => (Object.assign(Object.assign({}, HelixStyles.style_06_medium), { backgroundColor: HelixPalette.white, border: 'none', height: 76, padding: 0, width: 100, '&:focus': { outline: 'none' }, '&[data-current=true]': { color: HelixPalette.pink60 }, '&:hover': {
        backgroundColor: HelixPalette.teal10,
        cursor: 'pointer',
    }, '&:active:focus': { backgroundColor: HelixPalette.teal20 }, '&:focus-visible': {
        backgroundColor: HelixPalette.blue70,
        color: HelixPalette.white,
        svg: { color: HelixPalette.white },
    } })));
